import { useContent } from "@/lib/content";

export const Marquee = () => {
  const { MARQUEE } = useContent();
  const row = [...MARQUEE, ...MARQUEE];
  return (
    <div data-testid="marquee-section" className="relative overflow-hidden border-y border-gold/15 bg-roast py-7">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={i} className="flex items-center font-display text-3xl italic text-sand md:text-5xl">
                <span className="px-8">{w}</span>
                <span className="text-lg not-italic text-gold">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
